<div class="progress-bar">
  <div class="progress"  [class.indeterminate]="indeterminate()" [style.width]="(progress()) + '%'"></div>
</div>
